export const NAME = 'NAME'
export const NAME_AND_SKU = 'NAME_AND_SKU'
export const SKU = 'SKU'
